export const BOTTOM_BAR_HEIGHT = 37;
